import { SubsectionTitle } from '@sleepstation/components'
import { VLayout } from '@sleepstation/components-layouts'
import { LAYOUT_SPACING } from '@sleepstation/const'
import { propIsFalse, propIsTrue } from '@sleepstation/utils'
import PropTypes from 'prop-types'
import { filter, find, path, sortBy } from 'ramda'
import React from 'react'
import styled from 'styled-components'
import AuthorList from './AuthorList'
import LeadAuthor from './LeadAuthor'

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const AUTHORS_TITLE = `Authors`

// -----------------------------------------------------------------------------
// Utils
// -----------------------------------------------------------------------------

const findLeadAuthor = find(propIsTrue(`isLead`))

const filterNonLeadAuthor = filter(propIsFalse(`isLead`))

const sortBySurname = sortBy(path([`surname`]))

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled(VLayout).attrs({ spacing: LAYOUT_SPACING.X_LARGE })``

const Header = styled.header``

const Body = styled.div``

const Footer = styled(VLayout).attrs({
  as: `footer`,
  spacing: [LAYOUT_SPACING.LARGE, LAYOUT_SPACING.X_LARGE],
})``

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const AuthorsSummary = ({ title, authors }) => {
  const leadAuthor = findLeadAuthor(authors)
  const otherAuthors = filterNonLeadAuthor(authors)
  const otherAuthorsBySurname = sortBySurname(otherAuthors)
  return (
    <Layout>
      <Header>
        <SubsectionTitle>{title}</SubsectionTitle>
      </Header>
      <Body>
        <LeadAuthor author={leadAuthor} />
      </Body>
      <Footer>
        <SubsectionTitle>{AUTHORS_TITLE}</SubsectionTitle>
        <AuthorList authors={otherAuthorsBySurname} />
      </Footer>
    </Layout>
  )
}

AuthorsSummary.propTypes = {
  title: PropTypes.string.isRequired,
  authors: PropTypes.arrayOf(PropTypes.object).isRequired,
}

AuthorsSummary.defaultProps = {}

export default AuthorsSummary
